import { Autocomplete, Box, TextField } from '@mui/material';
import { debounce } from 'lodash';
import { ReactNode, useCallback } from 'react';

// Components
import PaperSelect from 'src/components/common/PaperSelect';
import TooltipFormLabel from 'src/components/common/TooltipFormLabel';

// Utilities
import iconSearch from 'src/asset/icons/icon-search.svg';
import FlagCountry from 'src/components/common/FlagCountry';

interface IProps {
  id: string;
  countryCode?: string;
  defaultKeyword?: string;
  required?: boolean;
  tooltipText?: string;
  label?: ReactNode;
  disabled?: boolean;
  isError?: boolean;
  value?: any;
  inputValue?: string;
  onChange: any;
  onTextInputChange?: any;
  options: any[];
  loading?: boolean;
  onBlur?: any;
  placeholder?: string;
  labelField?: string;
  countryCodeField?: string;
  getOptionKeyFn: (option: any) => any;
  getOptionLabel?: (option: any) => any;
}

const FormAutoCompleteByCountry = ({
  id,
  countryCode,
  tooltipText = '',
  label,
  required = false,
  disabled = false,
  isError,
  value,
  onChange,
  onTextInputChange,
  options,
  loading,
  inputValue,
  onBlur,
  placeholder,
  labelField,
  countryCodeField = 'country_code',
  getOptionLabel,
  getOptionKeyFn,
}: IProps) => {
  const handleTextInputChange = useCallback(
    debounce((e) => {
      onTextInputChange && onTextInputChange(e.target.value);
    }, 500),
    [],
  );

  const getLabelFn = (option: any) => {
    if (getOptionLabel) return getOptionLabel(option);
    if (labelField) return option[labelField];
    return '';
  };

  return (
    <Autocomplete
      value={value}
      onChange={(_, value) => onChange(value)}
      loading={loading}
      onBlur={onBlur}
      freeSolo
      fullWidth
      id={id}
      size="small"
      autoComplete
      options={options}
      disabled={disabled}
      popupIcon={<Box component={'img'} src={iconSearch} />}
      getOptionKey={(option) => getOptionKeyFn(option)}
      PaperComponent={PaperSelect}
      autoHighlight
      getOptionLabel={getLabelFn}
      renderOption={(props, option) => {
        return (
          <Box gap={1} display={'flex'} component="li" {...props}>
            <FlagCountry width={24} code={option[countryCodeField] || ''} />
            {getLabelFn(option)}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          id={`${id}-text`}
          required={required}
          value={inputValue}
          error={isError}
          InputLabelProps={{
            ...params.InputLabelProps,
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: countryCode ? <FlagCountry width={24} code={countryCode} /> : null,
            // endAdornment: (
            //   <Stack alignItems={'center'}>
            //     {!loading ? <CircularProgress className={'auto-complete-by-country-loading-indicator'} color="primary" size={16} /> : null}
            //     <Box>{params.InputProps.endAdornment}</Box>
            //   </Stack>
            // ),
          }}
          placeholder="Typing..."
          onChange={handleTextInputChange}
          label={
            label ? (
              label
            ) : (
              <span>
                {placeholder} {tooltipText && <TooltipFormLabel title={tooltipText} />}
              </span>
            )
          }
        />
      )}
    />
  );
};

export default FormAutoCompleteByCountry;
